import { render, staticRenderFns } from "./kj.vue?vue&type=template&id=38d14964&scoped=true"
import script from "./kj.vue?vue&type=script&lang=js"
export * from "./kj.vue?vue&type=script&lang=js"
import style0 from "./kj.vue?vue&type=style&index=0&id=38d14964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d14964",
  null
  
)

export default component.exports